import type { IProjectRepository, ProjectCreateInput } from '../repositories/IProjectRepository.js';
import type { ProjectEntity } from '../entities/ProjectEntity.js';

interface Deps { projectRepository: IProjectRepository; }

export function createCreateProjectUseCase({ projectRepository }: Deps) {
  return async function createProject(input: ProjectCreateInput): Promise<ProjectEntity> {
    return projectRepository.create(input);
  };
}
